module.exports = __webpack_public_path__ + "components/MapControl/svg/Plaża_kąpielisko.svg?b8b86b29";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Plaża_kąpielisko.svg
// module id = 2074
// module chunks = 0